import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const alertVariants = cva(
  "rounded-xl border px-4 py-3 text-sm animate-[fadeIn_220ms_ease-out]",
  {
    variants: {
      variant: {
        default:
          "border-[var(--color-border)] bg-[var(--color-card)] text-[var(--color-foreground)]",
        destructive:
          "border-[var(--color-destructive)]/30 bg-[var(--color-destructive)]/8 text-[var(--color-destructive)]",
        muted:
          "border-[var(--color-border)] bg-[var(--color-background)]/80 text-[var(--color-muted)]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface AlertProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof alertVariants> {}

export function Alert({ className, variant, ...props }: AlertProps) {
  return (
    <div
      role="status"
      className={cn(alertVariants({ variant }), className)}
      {...props}
    />
  );
}
